/**
 * A clickable response module:
 *
 * behavior:
 *
 * - listens for click event
 * - if the target of the event is data-response=FOO then set our dataset.responded=FOO
 *
 * store that response in localstorage, per page
 */
SNI.Application.addModule('clickable-response', context => {

  const debug = context.getService('logger').create('module.clickable-response');

  const mdManager = context.getGlobal('mdManager');
  const detailId = mdManager?.getDetailId() || 'unknown';
  const storageKey = 'clickable-response-' + detailId + '-' + context.getConfig().responseName;
  const storage = window.localStorage;

  return {

    init() {
      debug.log('init', storageKey);
      const storedResponse = storage?.getItem(storageKey);
      if (storedResponse) {
        debug.log('restored response from localStorage', storedResponse);
        context.getElement().dataset.responded = storedResponse;
      }
    },

    onclick(event) {
      const response = event.target.closest('[data-response]')?.dataset.response;
      if (response) {
        debug.log('response clicked', response);
        context.getElement().dataset.responded = response;
        storage?.setItem(storageKey, response);
      }
    }

  };
});
